<template>
  <div>
    <!-- 拜访统计 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center p-b-16">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">拜访统计</span>
      </div>

      <div class="flex row-between p-b-20">
        <div class="width-49 bg-C8FFFD b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="反馈次数" class="width-100 height-100" src="@/assets/icon/employeeKanban/fankui.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{boardData.visit?.visitCompanyNum}}</div>
            <div class="font-24">拜访客户数</div>
          </div>
        </div>

        <div class="width-49 bg-FFEDCF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24">
          <div class="w-72 h-72 m-r-16">
            <img alt="未反馈" class="width-100 height-100" src="@/assets/icon/employeeKanban/weifankui.png">
          </div>
          <div>
            <div class="font-40 font-weight-700">{{boardData.visit?.visitCustomerNum}}</div>
            <div class="font-24">拜访联系人</div>
          </div>
        </div>
      </div>
      <div class="font-28 text-center">
        共拜访<span class="font-weight-700">{{boardData.visit?.visitNum}}</span>次，在{{boardData?.unitUserNum}}人中排名第<span class="font-weight-700">{{boardData.visit?.visitRank}}</span>
      </div>
    </div>

    <!-- 合同签订 -->
    <ContractCarousel :carouselData="boardData.contractList" :bgImg="contractBgImg" :type="1" />

    <!-- 回款明细 -->
    <ContractCarousel :carouselData="boardData.receiveList" :bgImg="paymentCollectionBgImg" :type="2" />
  </div>
</template>

<script>
import TitleLogo from "@/components/TitleLogo.vue";
import ContractCarousel from './ContractCarousel.vue'

export default {
  components: {TitleLogo, ContractCarousel},
  props: {
    boardData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      contractBgImg: require('@/assets/icon/employeeKanban/hetongBg.png'),
      paymentCollectionBgImg: require('@/assets/icon/employeeKanban/huikuanBg.png')
    }
  },
  mounted() {

  },
  methods: {},
};
</script>

<style lang="less" scoped>
</style>
